// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-divider {
  display: inline-block;
  vertical-align: top;
  border-left: 1px solid rgb(234.6, 234.6, 234.6);
  margin-left: 8px;
  margin-right: 8px;
  height: 21px;
}

/* .individual-view {
	height: calc(100vh - 48px - 24px - 80px);
	//margin-right: -17px;
}
 */
a.list-row, a.list-row * {
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.list-view, .list-view-group {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
}
.list-view.with-padding-right .list-row, .with-padding-right.list-view-group .list-row {
  padding-right: 10px;
}
.list-view .list-row, .list-view-group .list-row {
  display: block;
  padding: 5px;
}
.list-view .list-row .pull-right, .list-view-group .list-row .pull-right {
  text-align: right;
}
.list-view .disabled-icons:not(.disabled-row) .action-item, .list-view-group .disabled-icons:not(.disabled-row) .action-item {
  opacity: 0.5;
}
.list-view .trip-date-row, .list-view-group .trip-date-row {
  padding: 0 0 0 5px;
  margin-top: 5px;
  line-height: 32px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.list-view .trip-date-row .material-icons, .list-view-group .trip-date-row .material-icons {
  vertical-align: middle;
}
.list-view .trip-date-row .pull-right, .list-view-group .trip-date-row .pull-right {
  margin-left: auto;
}
.list-view a, .list-view-group a {
  color: inherit;
}
.list-view .not-updated .action-running, .list-view-group .not-updated .action-running {
  opacity: 0.25;
}
.list-view .action-item, .list-view-group .action-item {
  float: left;
}
.list-view .action-item a, .list-view-group .action-item a {
  display: block;
}
.list-view .action-item .material-icons, .list-view-group .action-item .material-icons, .list-view .action-item i, .list-view-group .action-item i {
  color: inherit;
  vertical-align: middle;
}
.list-view .action-item.unknownunknown, .list-view-group .action-item.unknownunknown, .list-view .action-item.unknownonline, .list-view-group .action-item.unknownonline {
  opacity: 0.25;
}
.list-view .action-item.online, .list-view-group .action-item.online {
  color: #28a745;
}
.list-view .action-item.unknownunknown, .list-view-group .action-item.unknownunknown, .list-view .action-item.unknown, .list-view-group .action-item.unknown {
  color: #ffc107;
}
.list-view .action-item.stop, .list-view-group .action-item.stop {
  color: #dc3545;
}
.list-view .action-item.offline, .list-view-group .action-item.offline {
  color: #b7b7b7;
}
.list-view .action-item.away, .list-view-group .action-item.away {
  color: #ffc107;
}
.list-view .action-item .sub-menu, .list-view-group .action-item .sub-menu {
  min-width: 200px;
}
.list-view .action-item.action-connection.offline, .list-view-group .action-item.action-connection.offline {
  color: #dc3545;
}
.list-view .action-item.action-connection.not-exists, .list-view-group .action-item.action-connection.not-exists {
  color: #b7b7b7;
}
.list-view .action-item.action-connection.not-updated, .list-view-group .action-item.action-connection.not-updated {
  color: #0288d1;
}
.list-view .action-clear-list, .list-view-group .action-clear-list {
  color: #dc3545;
}
.list-view .action-clear-list a, .list-view-group .action-clear-list a {
  cursor: pointer;
}
.list-view, .list-view-group {
  /* .action-ellipsis {
  	visibility: hidden;
  } */
}

.tracks-list-row {
  padding: 0px;
  margin-bottom: 6px;
  border-radius: 6px;
  position: relative;
}
.tracks-list-row .action-item {
  margin-top: 0 !important;
}

.tracks-list-row-head {
  border: none !important;
  white-space: nowrap;
  display: flex;
}
.tracks-list-row-head .trip-duration {
  min-width: 65px;
  margin-left: auto;
}
.tracks-list-row-head .trip-entity {
  font-weight: bold;
  border: none !important;
  text-indent: 5px;
}
.tracks-list-row-head .trip-distance {
  min-width: 85px;
}

.tracks-list-row-wrap {
  position: relative;
}

.tracks-list-view {
  margin: 0;
  padding: 0;
  list-style: none;
}

.trip-entity {
  font-weight: normal;
  margin-right: 2px;
}

.trip-time,
.trip-distance {
  padding-right: 4px;
  min-width: 60px;
  display: inline-block;
}

.color-box {
  width: 10px;
  height: 10px;
  border-radius: 20px;
  display: block;
}

.trip-time {
  min-width: 65px;
}

.list-view-group > li .list-row {
  border-left: 5px solid;
}

.group-view .list-view-group .list-row {
  padding-left: 5px;
}
.group-view .list-view-group .list-row .unit-name {
  font-weight: 700;
  max-width: 130px;
  min-width: 130px;
}
.group-view .list-view-group .list-row .unit-name-full {
  min-width: inherit;
  max-width: none;
}

.action-item svg {
  display: block;
}

.unit-name {
  max-width: 155px;
  min-width: 155px;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  text-overflow: ellipsis;
  line-height: 18px;
  margin-left: 5px;
  vertical-align: middle;
}
.unit-name img {
  max-width: 20px;
  height: auto;
  vertical-align: middle;
  margin-right: 5px;
}
.unit-name.unit-name-full {
  min-width: inherit;
  max-width: none;
}

.checkbox.full {
  display: block;
  width: auto;
}
.checkbox.full .unit-name {
  display: block;
  min-width: inherit !important;
  max-width: none !important;
}

.unit-details-box {
  background: #fff;
  padding: 10px;
  border-bottom: 1px solid transparent;
}
.unit-details-box .time-address-row {
  margin-top: 0;
  line-height: 1.7;
}
.unit-details-box .statistics-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin-bottom: 10px;
}
.unit-details-box .statistics-table td {
  text-align: center;
  border: 1px solid transparent;
  vertical-align: middle;
  padding: 10px;
}
.unit-details-box .caption-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
}
.unit-details-box .caption-table td {
  border: 1px solid transparent;
  vertical-align: middle;
  padding: 5px 10px;
}
.unit-details-box .caption-table th {
  border: 1px solid transparent;
  background: #fff;
  font-weight: normal;
  padding: 5px 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Devices/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAGA;EACC,qBAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAFD;;AAKA;;;;EAAA;AAMA;EACC,qBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AAHD;;AAKA;EACC,SAAA;EACA,UAAA;EACA,gBAAA;EACA,eCoDc;ADtDf;AAGC;EACC,mBAAA;AADF;AAGC;EACC,cAAA;EACA,YAAA;AADF;AAGE;EACC,iBAAA;AADH;AAME;EACC,YAAA;AAJH;AAOC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AALF;AAUE;EACC,sBAAA;AARH;AAWE;EACC,iBAAA;AATH;AAaC;EACE,cAAA;AAXH;AAcE;EACC,aAAA;AAZH;AAgBC;EACC,WAAA;AAdF;AAeE;EACC,cAAA;AAbH;AAeE;EACC,cAAA;EACA,sBAAA;AAbH;AAeE;EAEC,aAAA;AAdH;AAgBE;EACC,cCpCU;ADsBb;AAgBE;EAEC,cCrCW;ADsBd;AAiBE;EACC,cC1CQ;AD2BX;AAiBE;EACC,cCzCS;AD0BZ;AAiBE;EACC,cC9CW;AD+Bd;AAoBE;EACC,gBAAA;AAlBH;AAqBC;EAEC,cC3DS;ADuCX;AAsBC;EACC,cC1DU;ADsCZ;AAsBC;EACC,cAAA;AApBF;AAuBC;EACC,cCrES;ADgDX;AAsBE;EACC,eAAA;AApBH;AAjFA;EA0GC;;KAAA;AApBD;;AAwBA;EACC,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AArBD;AAsBC;EACC,wBAAA;AApBF;;AAwBA;EACC,uBAAA;EACA,mBAAA;EACA,aAAA;AArBD;AAsBC;EACC,eAAA;EACA,iBAAA;AApBF;AAsBC;EACC,iBAAA;EACA,uBAAA;EACA,gBAAA;AApBF;AAuBC;EACC,eAAA;AArBF;;AAwBA;EACC,kBAAA;AArBD;;AAuBA;EACC,SAAA;EACA,UAAA;EACA,gBAAA;AApBD;;AAsBA;EACC,mBAAA;EACA,iBAAA;AAnBD;;AAqBA;;EAEC,kBAAA;EACA,eAAA;EACA,qBAAA;AAlBD;;AAoBA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAjBD;;AAmBA;EACC,eAAA;AAhBD;;AAoBC;EACC,sBAAA;AAjBF;;AAsBC;EACC,iBAAA;AAnBF;AAoBE;EACC,gBAAA;EACA,gBAAA;EACA,gBAAA;AAlBH;AAoBE;EACI,kBAAA;EACA,eAAA;AAlBN;;AAuBA;EAAmB,cAAA;AAnBnB;;AAuBA;EAEI,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AArBJ;AAsBI;EACC,eAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;AApBL;AAuBI;EACC,kBAAA;EACA,eAAA;AArBL;;AAyBA;EACC,cAAA;EACA,WAAA;AAtBD;AAuBC;EACC,cAAA;EACA,6BAAA;EACA,0BAAA;AArBF;;AAyBA;EACC,gBAAA;EACA,aAAA;EACA,oCAAA;AAtBD;AAuBC;EACC,aAAA;EACA,gBAAA;AArBF;AAuBC;EACC,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AArBF;AAsBE;EACC,kBAAA;EACA,6BAAA;EACA,sBAAA;EACA,aAAA;AApBH;AAuBC;EACC,WAAA;EACA,yBAAA;EACA,mBAAA;AArBF;AAsBE;EACC,6BAAA;EACA,sBAAA;EACA,iBAAA;AApBH;AAsBE;EACC,6BAAA;EACA,gBCjNiB;EDkNjB,mBAAA;EACA,iBAAA;AApBH","sourcesContent":["@import \"../../assets/variables\";\n\n// List Row\n.v-divider {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tborder-left: 1px solid darken($sidebarRowBg, 8%);\n\tmargin-left: 8px;\n\tmargin-right: 8px;\n\theight: 21px;\n}\n\n/* .individual-view {\n\theight: calc(100vh - #{$headerHeight} - #{$footerHeight} - 80px);\n\t//margin-right: -17px;\n}\n */\n\na.list-row,a.list-row * { \n\ttext-decoration: none;\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\talign-items: center;\n}\n.list-view {\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style: none;\n\tfont-size: $baseFontSize;\n\t&.with-padding-right .list-row {\n\t\tpadding-right: 10px;\n\t}\n\t.list-row {\n\t\tdisplay: block;\n\t\tpadding: 5px;\t\t\t\n\t\t//border-bottom: 1px solid darken($sidebarRowBg, 8%);\n\t\t.pull-right {\n\t\t\ttext-align: right;\n\t\t}\n\n\t}\n\t.disabled-icons:not(.disabled-row) {\n\t\t.action-item {\n\t\t\topacity: 0.5;\n\t\t}\n\t}\n\t.trip-date-row {\n\t\tpadding: 0 0 0 5px;\n\t\tmargin-top: 5px;\n\t\tline-height: 32px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\n\t\t//span {\n\t\t\t//font-weight: 300;\n\t\t//}\n\t\t.material-icons {\n\t\t\tvertical-align: middle;\n\t\t}\n\n\t\t.pull-right {\n\t\t\tmargin-left: auto;\n\t\t}\n\t}\n\t\n\ta {\n\t \tcolor: inherit;\n\t}\n\t.not-updated {\n\t\t.action-running {\n\t\t\topacity: 0.25;\n\t\t}\n\n\t}\n\t.action-item {\n\t\tfloat: left;\n\t\ta {\n\t\t\tdisplay: block;\n\t\t}\n\t\t.material-icons, i {\n\t\t\tcolor: inherit;\n\t\t\tvertical-align: middle;\n\t\t}\n\t\t&.unknownunknown,\n\t\t&.unknownonline {\n\t\t\topacity: 0.25;\n\t\t}\n\t\t&.online {\n\t\t\tcolor: $greenColor;\n\t\t}\n\t\t&.unknownunknown,\n\t\t&.unknown {\n\t\t\tcolor: $yellowColor;\n\t\t}\t\t\n\t\t&.stop {\n\t\t\tcolor: $redColor;\n\t\t}\n\t\t&.offline {\n\t\t\tcolor: $lightGrey;\n\t\t}\n\t\t&.away {\n\t\t\tcolor: $yellowColor;\n\t\t}\n\t\t.circle {\n\t\t\t//margin-top: -0.2em;\n\t\t}\n\t\t.sub-menu {\n\t\t\tmin-width: 200px;\n\t\t}\n\t}\n\t.action-item.action-connection.offline {\n\t\t//color: #0288d1;\n\t\tcolor: $redColor;\n\t}\n\t.action-item.action-connection.not-exists {\n\t\tcolor: $lightGrey;\n\t}\n\t.action-item.action-connection.not-updated {\n\t\tcolor: #0288d1;\n\t}\n\n\t.action-clear-list {\n\t\tcolor: $redColor;\n\t\ta {\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t\n\t/* .action-ellipsis {\n\t\tvisibility: hidden;\n\t} */\n}\n.tracks-list-row {\n\tpadding: 0px;\n\tmargin-bottom: 6px;\n\tborder-radius: 6px;\n\tposition: relative;\n\t.action-item {\n\t\tmargin-top: 0 !important;\n\t}\n\t\n}\n.tracks-list-row-head {\n\tborder: none !important;\n\twhite-space: nowrap;\n\tdisplay: flex;\n\t.trip-duration {\n\t\tmin-width: 65px;\n\t\tmargin-left: auto;\n\t}\n\t.trip-entity {\n\t\tfont-weight: bold;\n\t\tborder: none !important;\n\t\ttext-indent: 5px;\n\t\t// display: inline-block;\n\t}\n\t.trip-distance {\n\t\tmin-width: 85px;\n\t}\n}\n.tracks-list-row-wrap {\n\tposition: relative;\n}\n.tracks-list-view {\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style: none;\n}\n.trip-entity {\n\tfont-weight: normal;\n\tmargin-right: 2px;\n}\n.trip-time,\n.trip-distance {\n\tpadding-right: 4px;\n\tmin-width: 60px;\n\tdisplay: inline-block;\n}\n.color-box {\n\twidth: 10px;\n\theight: 10px;\n\tborder-radius: 20px;\n\tdisplay: block;\n}\n.trip-time {\n\tmin-width: 65px;\n}\n.list-view-group {\n\t@extend .list-view;\n\t> li .list-row {\n\t\tborder-left: 5px solid;\n\t}\n}\n\n.group-view {\n\t.list-view-group .list-row {\n\t\tpadding-left: 5px;\n\t\t.unit-name {\n\t\t\tfont-weight: 700;\n\t\t\tmax-width: 130px;\n\t\t\tmin-width: 130px;\n\t\t}\n\t\t.unit-name-full {\n\t    \tmin-width: inherit;\n\t    \tmax-width: none;\n\t    }\n\t}\n}\n\n.action-item svg { display: block;}\n\n\n\n.unit-name {\n\t\n    max-width: 155px;\n    min-width: 155px;\n    overflow: hidden;\n    white-space: nowrap;\n    display: inline-block;\n    text-overflow: ellipsis;\n    line-height: 18px;\n    margin-left: 5px;\n    vertical-align: middle;\n    img {\n\t    max-width: 20px;\n\t    height: auto;\n\t    vertical-align: middle;\n\t    margin-right: 5px;\n\n    }\n    &.unit-name-full {\n    \tmin-width: inherit;\n    \tmax-width: none;\n    }\n}\n\n.checkbox.full {\n\tdisplay: block;\n\twidth: auto;\n\t.unit-name {\n\t\tdisplay: block;\n\t\tmin-width: inherit !important;\n\t\tmax-width: none !important;\n\t}\n}\n\n.unit-details-box {\n\tbackground: #fff;\n\tpadding: 10px;\n\tborder-bottom: 1px solid $borderColor;\n\t.time-address-row {\n\t\tmargin-top: 0;\n\t\tline-height: 1.7;\n\t}\n\t.statistics-table {\n\t\twidth: 100%;\n\t\tborder-collapse:  collapse;\n\t\tfont-size: $baseFontSize + 2;\n\t\tmargin-bottom: 10px;\n\t\ttd {\n\t\t\ttext-align: center;\n\t\t\tborder: 1px solid $borderColor;\n\t\t\tvertical-align: middle;\n\t\t\tpadding: 10px;\n\t\t}\n\t}\n\t.caption-table {\n\t\twidth: 100%;\n\t\tborder-collapse:  collapse;\n\t\tmargin-bottom: 10px;\n\t\ttd {\n\t\t\tborder: 1px solid $borderColor;\n\t\t\tvertical-align: middle;\n\t\t\tpadding: 5px 10px;\n\t\t}\n\t\tth {\n\t\t\tborder: 1px solid $borderColor;\n\t\t\tbackground: $sidebarBackground;\n\t\t\tfont-weight: normal;\n\t\t\tpadding: 5px 10px;\n\t\t}\n\t}\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$filterColWidth: 72px;\n$sidebarWidth : 306px;\n$sidebarMaintenanceWidth: $sidebarWidth + 131px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 44px;\n$headerNavWidth: 150px;\n$headerHeight: 48px;\n$footerHeight: 24px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 1;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: transparent;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #ffffff;\n$lightGrey: #b7b7b7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 99999;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Inter, sans-serif;\n$altFontFamily: 'Bebas Neue', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
